import React, { FC, ReactElement } from 'react'
import { useLocation } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'

import { translate } from '../../../helpers/translations/translator'
import LoketHoursPerPeriodPage from '../../../pages/Absences/LoketHoursPerPeriod'
import Documents from '../../../pages/Documents/Documents'
import { InactiveUserPage } from '../../pages'
import { InactiveUserTopBar } from './subcomponents'

const InactiveUserRouteGroup: FC = (): ReactElement => {
    const location = useLocation()

    return (
        <div className="inactive-user-route-group">
            <InactiveUserTopBar showBackButton={location.pathname !== '/'} />

            <Switch>
                <Route
                    exact
                    path={`/${translate('nav.documents.link')}`}
                    component={Documents}
                />

                <Route
                    exact
                    path={`/${translate('nav.absences.link')}/${translate('nav.absences.loketHoursPerPeriod.link')}`}
                    component={LoketHoursPerPeriodPage}
                />

                <Route
                    exact
                    path="/"
                    component={InactiveUserPage}
                />

                <Redirect to="/" />
            </Switch>
        </div>
    )
}

export default InactiveUserRouteGroup
